import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { EmojiNodeWrapper } from './Emoji';
import { emojiNodeStyles, commonSelectedStyles, selectOnHoverStyles } from './styles';
var emojiFallbackStyles = css({
  display: 'flex',
  width: '100%',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden'
});
export var EmojiFallback = function EmojiFallback(props) {
  var emoji = props.emoji,
    selected = props.selected,
    selectOnHover = props.selectOnHover,
    className = props.className;
  var fallback = emoji.fallback,
    shortName = emoji.shortName;
  var classes = "".concat(emojiNodeStyles, " ").concat(selected ? commonSelectedStyles : '', " ").concat(selectOnHover ? selectOnHoverStyles : '', " ").concat(className ? className : '');
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    jsx(EmojiNodeWrapper, _extends({
      type: "image"
    }, props, {
      className: classes
    }), jsx("span", {
      css: emojiFallbackStyles
    }, fallback || shortName))
  );
};
export default EmojiFallback;